import WeLoveThisGameHero from './we-love-this-game-hero'

export default WeLoveThisGameHero
